module.exports = __webpack_public_path__ + "img/app_logo_alpha_x2.68369fec.png";